import { motion } from 'framer-motion';
import { trackCtaClick } from '../utils/analytics';

export default function HeroSection() {
  const scrollToContact = () => {
    trackCtaClick('hero_cta');
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative h-screen w-full overflow-hidden">
      {/* Background image - Rich, layered decor shot with depth */}
      <div className="absolute inset-0">
        <img
          src="/portfolio/page12_img2.jpeg"
          alt="CinCin Events - Luxury celebration design"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-24 px-6 md:px-16 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.5 }}
          className="max-w-3xl"
        >
          <h1
            data-testid="hero-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.1] tracking-tight"
          >
            Celebrations, Designed<br />
            <em className="font-light">to be Remembered.</em>
          </h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.2 }}
            data-testid="hero-subtext"
            className="mt-6 text-white/80 text-sm sm:text-base font-light tracking-[0.15em] uppercase"
          >
            Intimate. Intentional. Unforgettable.
          </motion.p>

          <motion.button
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.6 }}
            onClick={scrollToContact}
            data-testid="hero-cta-button"
            className="mt-10 px-8 py-3.5 rounded-full border border-white/60 text-white text-xs tracking-[0.2em] uppercase font-light hover:bg-white hover:text-[#0A0A0A] transition-all duration-500"
          >
            Begin Your Experience
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}
